var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.widgetComponent,{tag:"component",attrs:{"widget":_vm.widget,"page-id":_vm.pageId,"page-target":_vm.pageTarget,"row":_vm.row,"num-loading":_vm.numLoadingPerWidget}})}
var staticRenderFns = []

export { render, staticRenderFns }